export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/linkedinLogo.674f9e36.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};